import { render } from "./AddZonePage.vue?vue&type=template&id=13e74dab&ts=true"
import script from "./AddZonePage.vue?vue&type=script&lang=ts"
export * from "./AddZonePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__